import ActivityIcon from '@/components/Icons/ActivityIcon';
import CardIcon from '@/components/Icons/CardIcon';
import KeyIcon from '@/components/Icons/KeyIcon';
import SettingsIcon from '@/components/Icons/SettingsIcon';
import ShieldIcon from '@/components/Icons/ShieldIcon';
import UserPlusIcon from '@/components/Icons/UserPlusIcon';
import { Tabs as SettingsTabs } from '@/pages/Settings/Tabs/types';
import { BasetenPageEnum } from '@/routes';

import { AppLink, MenuItem } from '../styled';
import { Container } from './styled';

function Footer() {
  return (
    <Container>
      <MenuItem>
        <AppLink page={BasetenPageEnum.Settings} params={{ tabId: SettingsTabs.General }}>
          <SettingsIcon color="secondary" /> General settings
        </AppLink>
      </MenuItem>
      <MenuItem>
        <AppLink page={BasetenPageEnum.Settings} params={{ tabId: SettingsTabs.Members }}>
          <UserPlusIcon color="secondary" /> Members
        </AppLink>
      </MenuItem>
      {ENV_CONFIG.SHOW_BILLING_UI && (
        <MenuItem>
          <AppLink page={BasetenPageEnum.Settings} params={{ tabId: SettingsTabs.Billing }}>
            <CardIcon color="secondary" /> Billing and usage
          </AppLink>
        </MenuItem>
      )}
      <MenuItem>
        <AppLink page={BasetenPageEnum.Settings} params={{ tabId: SettingsTabs.ActivityFeed }}>
          <ActivityIcon color="secondary" /> Activity
        </AppLink>
      </MenuItem>
      <MenuItem>
        <AppLink page={BasetenPageEnum.Settings} params={{ tabId: SettingsTabs.Secrets }}>
          <ShieldIcon color="secondary" /> Secrets
        </AppLink>
      </MenuItem>
      <MenuItem>
        <AppLink page={BasetenPageEnum.Settings} params={{ tabId: SettingsTabs.ApiKeys }}>
          <KeyIcon color="secondary" /> API keys
        </AppLink>
      </MenuItem>
    </Container>
  );
}

export default Footer;
